var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSquareUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Square Up Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3 6.25C3 4.45507 4.45507 3 6.25 3H17.75C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25ZM13.4905 9.49994L8.22232 14.7171C7.928 15.0086 7.92569 15.4834 8.21715 15.7777C8.50862 16.0721 8.98349 16.0744 9.2778 15.7829L14.5 10.6113V15.2499C14.5 15.6642 14.8358 15.9999 15.25 15.9999C15.6642 15.9999 16 15.6642 16 15.2499V8.74994C16 8.33573 15.6642 7.99994 15.25 7.99994H8.75C8.33579 7.99994 8 8.33573 8 8.74994C8 9.16415 8.33579 9.49994 8.75 9.49994H13.4905Z",
    fill: "#05495A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareUpRight);
export default __webpack_public_path__ + "static/media/arrow-square-up-right.f7fbe2b3b16fdbb7a7242a2a22cd93f9.svg";
export { ForwardRef as ReactComponent };